/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import LabTestItemLimit from './lab-test-item-limit';
import LabTestItemLimitDetail from './lab-test-item-limit-detail';
import LabTestItemLimitUpdate from './lab-test-item-limit-update';
import LabTestItemLimitDeleteDialog from './lab-test-item-limit-delete-dialog';

const LabTestItemLimitRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<LabTestItemLimit />} />
    <Route path="new" element={<LabTestItemLimitUpdate />} />
    <Route path=":id">
      <Route index element={<LabTestItemLimitDetail />} />
      <Route path="edit" element={<LabTestItemLimitUpdate />} />
      <Route path="delete" element={<LabTestItemLimitDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default LabTestItemLimitRoutes;
